// ===== Packages =====

import {
    FirebaseError,
} from 'firebase/app';

// ===== Constants =====
import {
    SNACKBAR_MESSAGE_VERIFY_EMAIL_FALLBACK_ERROR,
    SNACKBAR_MESSAGE_VERIFY_EMAIL_GENERAL_ERROR,
    SNACKBAR_MESSAGE_VERIFY_EMAIL_RATE_LIMIT,
} from '../constants/generalConstants';

const VERIFY_EMAIL_RATE_LIMIT_FUNCTIONS_ERROR_CODE = 'functions/resource-exhausted';
const VERIFY_EMAIL_RATE_LIMIT_ERROR_CODE = 'resource-exhausted';
const VERIFY_EMAIL_TOO_MANY_ATTEMPTS_ERROR_CODE = 'TOO_MANY_ATTEMPTS_TRY_LATER';

interface ICallableErrorLike {
    code?: string;
    message?: string;
}

/**
 * Converts callable failures from requesting a verification email into text
 * that is specific enough for the user to act on.
 */
const getVerifyEmailRequestErrorMessage = (error: unknown): string => {
    const callableError = error as ICallableErrorLike;
    const errorCode = callableError?.code || '';
    const errorMessage = callableError?.message || '';
    const isRateLimited = (
        errorCode === VERIFY_EMAIL_RATE_LIMIT_FUNCTIONS_ERROR_CODE
        || errorCode === VERIFY_EMAIL_RATE_LIMIT_ERROR_CODE
        || errorMessage.includes(SNACKBAR_MESSAGE_VERIFY_EMAIL_RATE_LIMIT)
        || errorMessage.includes(VERIFY_EMAIL_TOO_MANY_ATTEMPTS_ERROR_CODE)
    );

    if (isRateLimited) {
        return SNACKBAR_MESSAGE_VERIFY_EMAIL_RATE_LIMIT;
    }

    if (!(error instanceof FirebaseError)) {
        return SNACKBAR_MESSAGE_VERIFY_EMAIL_GENERAL_ERROR;
    }

    return SNACKBAR_MESSAGE_VERIFY_EMAIL_FALLBACK_ERROR(error.message);
};

export default getVerifyEmailRequestErrorMessage;
